import { appConfig } from '../../../config/customization';
import { medium } from '../../../constants/fonts';

export default {
  container: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    flexShrink: 0
  },
  textInputWrapper: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-end',
    alignItems: 'flex-start',
    width: '100%',
    height: '100%'
  },
  errorsContainer: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    width: '100%',
    marginTop: 8,
    height: 12
  },
  input: {
    fontFamily: 'inherit',
    fontSize: medium,
    width: '100%',
    borderColor: appConfig.colors.fieldBorders,
    backgroundColor: appConfig.colors.white,
    color: appConfig.colors.translucentBlack,
    paddingBottom: 5,
    outline: 'none',
    height: 30
  },
  inputPlaceholder: {
    color: appConfig.colors.gray
  },
  placeholder: {
    minHeight: 15
  }
};
